import * as Icons from "lucide-react";

export default function CategoryIcon({ name, className = "w-5 h-5" }) {
  const Lookup = Icons[name] || Icons.MapPin;
  return <Lookup className={className} strokeWidth={1.8} />;
}
